// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7455":"e8dfbb2e","9165":"116b0763"}[chunkId] + ".css";
};